<template>
  <main id="main">
    <div v-if="loading" class="d-flex justify-content-center align-items-center" style="height: 100vh;">
      <p>{{ t('loading') }}</p>
    </div>
    <div v-else>
      <div class="header_page">
        <p id="title_header_page">{{ t('edit_profile') }}</p>
        <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
      </div>
      <div class="p-3">
        <div class="d-flex align-items-start justify-content-center mt-4" @click="triggerFileInput">
          <div class="position-relative">
            <p style="right: -12rem; white-space: nowrap;" class="position-absolute">{{ t('select_pic_type') }}</p>
            <img style="bottom: -.5rem; right: -.5rem; z-index: 1;" src="@/assets/imgs/edit.svg" class="icon-size-5 position-absolute" alt="">
            <div v-if="isUploading" class="position-absolute w-100 h-100 rounded-pill bg-dark opacity-50 d-flex justify-content-center align-items-center text-white" style="z-index: 2;">...</div>
            <img style="width: 7rem; height: 7rem; object-fit: cover;" :src="profileImageUrl" class="rounded-pill border_theme shadow_input" alt="">
            <input type="file" ref="fileInput" @change="onFileSelected" style="display: none" accept="image/*">
          </div>
        </div>
        <div class="d-flex flex-wrap align-items-center justify-content-around gap-3 mt-3">
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('name') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <input class="rounded-pill p-3 shadow_input custom-placeholder" type="text" v-model="form.name" :placeholder="userInfo.name || t('name')">
          </div>
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('family') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <input class="rounded-pill p-3 shadow_input custom-placeholder" type="text" v-model="form.family" :placeholder="userInfo.family || t('family')">
          </div>
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('father_name') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <input class="rounded-pill p-3 shadow_input custom-placeholder" type="text" v-model="form.father_name" :placeholder="userInfo.father_name || t('father_name')">
          </div>
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('father_family') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <input class="rounded-pill p-3 shadow_input custom-placeholder" type="text" v-model="form.father_family" :placeholder="userInfo.father_family || t('father_family')">
          </div>
          <div class="d-flex flex-column w-45 position-relative">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('country') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <div class="custom-select-box p-3 w-100 rounded-pill d-flex align-items-center justify-content-between" @click="showCountryDropdown = !showCountryDropdown">
              <div class="d-flex align-items-center gap-2 overflow-hidden">
                <img v-if="selectedCountryObj" :src="selectedCountryObj.pic" class="option-icon" alt="">
                <span v-if="form.country" class="text-truncate">{{ form.country }}</span>
                <span v-else-if="userInfo.country" class="text-truncate text-muted">{{ userInfo.country }}</span>
                <span v-else class="text-muted small">{{ t('click_to_select') }}</span>
              </div>
              <i class="arrow-down">▼</i>
            </div>
            <ul v-if="showCountryDropdown" class="custom-options-list rounded shadow w-100 position-absolute bg-white z-index-1000">
              <li v-for="c in countries" :key="c.id" @click="selectCountry(c)" class="d-flex align-items-center gap-2 p-3 border-bottom cursor-pointer">
                <img :src="c.pic" class="option-icon" alt="">
                <span>{{ c.title }}</span>
              </li>
            </ul>
          </div>
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('age') }}</p><img src="@/assets/imgs/edit.svg" class="icon-size-4" alt=""></div>
            <input class="rounded-pill p-3 shadow_input custom-placeholder" type="number" v-model="form.age" :placeholder="userInfo.age || t('age')">
          </div>
          <div class="d-flex flex-column w-45">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>کد کاربری</p></div>
            <input class="rounded-pill p-3 shadow_input" type="text" disabled :value="userInfo.user_code || userInfo.ref_code">
          </div>
          
          <div class="d-flex flex-column w-45 position-relative">
            <div class="d-flex align-items-center gap-2 me-3 mb-2"><p>{{ t('teaching_grades') }}</p></div>
            <div class="custom-select-box p-3 w-100 rounded-pill d-flex align-items-center justify-content-between" style="background-color: #f8f9fa; cursor: default;">
              <div class="d-flex align-items-center gap-2 overflow-hidden">
                <img v-if="selectedGradeObj" :src="selectedGradeObj.pic" class="option-icon" alt="">
                <span v-if="selectedGradeObj" class="text-truncate">{{ selectedGradeObj.title }}</span>
                <span v-else-if="currentUserGradeTitle" class="text-truncate text-muted">{{ currentUserGradeTitle }}</span>
                <span v-else class="text-muted small">{{ t('click_to_select') }}</span>
              </div>
            </div>
          </div>

        </div>
        <div class="d-flex justify-content-center align-items-center mt-6">
          <button @click="submitUpdate" class="bg_gradient_theme_to_bottom button" :disabled="submitting || isUploading">
            {{ submitting ? t('loading') : (isUploading ? t('uploading') : 'ثبت اطلاعات') }}
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import { Decryption } from '@/utils/crypto'

export default {
  name: 'EditProfileView',
  data() {
    return {
      form: {
        name: '',
        family: '',
        father_name: '',
        father_family: '',
        country: '',
        age: '',
        grade_id: ''
      },
      userInfo: {},
      countries: [],
      grades: [],
      loading: true,
      submitting: false,
      showCountryDropdown: false,
      showGradeDropdown: false,
      profileImageUrl: require('@/assets/imgs/NoPath.svg'),
      uploadedFileName: '',
      isUploading: false,
    }
  },
  computed: {
    selectedCountryObj() {
      return this.countries.find(c => c.title === this.form.country);
    },
    selectedGradeObj() {
      return this.grades.find(g => String(g.id) === String(this.form.grade_id));
    },
    currentUserGradeTitle() {
      if (!this.userInfo.grade_id) return '';
      const g = this.grades.find(gr => String(gr.id) === String(this.userInfo.grade_id));
      return g ? g.title : '';
    }
  },
  mounted() {
    this.fetchInitialData();
  },
  methods: {
    async fetchInitialData() {
      this.loading = true;
      const userId = localStorage.getItem('user_id');

      try {
        const countryData = createFormData({ action: 'country', user_id: userId });
        const resCountry = await apiClient.post('/public_info', countryData);
        if (Array.isArray(resCountry.data)) {
          this.countries = resCountry.data;
        } else if (resCountry.data.data) {
          const raw = resCountry.data.data;
          this.countries = typeof raw === 'string' ? Decryption(raw) : raw;
        }

        const gradeData = createFormData({ action: 'grade', user_id: userId });
        const resGrade = await apiClient.post('/public_info', gradeData);
        if (Array.isArray(resGrade.data)) {
          this.grades = resGrade.data;
        } else if (resGrade.data.data) {
          const raw = resGrade.data.data;
          this.grades = typeof raw === 'string' ? Decryption(raw) : raw;
        }

        const userData = createFormData({ action: 'user_info', user_id: userId });
        const resUser = await apiClient.post('/public_info', userData);
        
        let decryptedUser = {};
        
        if (resUser.data.status === true && resUser.data.data) {
          if (typeof resUser.data.data === 'string') {
             decryptedUser = Decryption(resUser.data.data);
          } else {
             decryptedUser = resUser.data.data;
          }
        } else if (resUser.data.data) {
          decryptedUser = resUser.data.data;
        } else if (resUser.data.id) {
          decryptedUser = resUser.data;
        }

        if (decryptedUser) {
          this.userInfo = decryptedUser;
          
          let serverPic = decryptedUser.pic;
          const imageBaseUrl = 'https://back.ayendaman.org/storage/app/public/uploads/';
          if (serverPic && serverPic !== 'nopic.png' && !serverPic.includes('nopic')) {
             this.profileImageUrl = serverPic.startsWith('http') ? serverPic : imageBaseUrl + serverPic;
          } else {
             this.profileImageUrl = require('@/assets/imgs/NoPath.svg');
          }
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        this.loading = false;
      }
    },
    selectCountry(c) {
      this.form.country = c.title;
      this.showCountryDropdown = false;
    },
    selectGrade(g) {
      this.form.grade_id = g.id;
      this.showGradeDropdown = false;
    },
    triggerFileInput() {
      if (!this.isUploading) {
        this.$refs.fileInput.click();
      }
    },
    async onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.isUploading = true;

        const reader = new FileReader();
        reader.onload = e => { this.profileImageUrl = e.target.result; };
        reader.readAsDataURL(file);

        const formData = new FormData();
        formData.append('pic', file);
        formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

        try {
          const res = await apiClient.post('/upload_pic', formData);
          if (res.data.status === 'ok') {
            this.uploadedFileName = res.data.pic_name;
          } else {
            this.notify(this.t('upload_error'), 'error');
          }
        } catch (e) {
          console.error('Upload Error:', e);
          this.notify(this.t('upload_error'), 'error');
        } finally {
          this.isUploading = false;
        }
      }
    },
    async submitUpdate() {
      this.submitting = true;
      try {
        const userId = localStorage.getItem('user_id');
        
        const formData = createFormData({
          user_id: userId,
          name: this.form.name || this.userInfo.name,
          family: this.form.family || this.userInfo.family,
          father_name: this.form.father_name || this.userInfo.father_name,
          father_family: this.form.father_family || this.userInfo.father_family,
          country: this.form.country || this.userInfo.country,
          age: this.form.age || this.userInfo.age,
          grade_id: this.form.grade_id || this.userInfo.grade_id
        });
        
        if (this.uploadedFileName) {
          formData.append('pic', this.uploadedFileName);
        }
        
        const response = await apiClient.post('/edit_profile', formData);
        
        if (response.data.status === 'ok') {
          this.notify(response.data.message, 'success');
          this.$router.push({ name: 'UserProfile' });
        } else {
          this.notify(response.data.message || 'مشکل در ویرایش پروفایل', 'error');
        }
      } catch (error) {
        console.error("Error updating profile:", error);
        this.notify(this.t('connection_error'), 'error');
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
.custom-select-box {
  background-color: #fff;
  border: 1px solid #ddd;
  min-height: 52px;
  cursor: pointer;
}
.option-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
  border-radius: 50%;
}
.custom-options-list {
  list-style: none;
  padding: 0;
  margin: 5px 0 0 0;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ddd;
  z-index: 1000;
  top: 100%;
  left: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  background-color: #f8f9fa;
}
.z-index-1000 {
  z-index: 1000;
}
.arrow-down {
  font-size: 0.8rem;
  color: #666;
}
.text-muted {
  color: #9ca3af !important; 
}
.custom-placeholder::placeholder {
  color: #9ca3af !important;
  opacity: 1; 
}
.custom-placeholder::-webkit-input-placeholder {
  color: #9ca3af !important;
}
.custom-placeholder::-moz-placeholder {
  color: #9ca3af !important;
}
.custom-placeholder:-ms-input-placeholder {
  color: #9ca3af !important;
}
</style>